import { render, staticRenderFns } from "./demande.vue?vue&type=template&id=05133ef4"
import script from "./demande.vue?vue&type=script&lang=js"
export * from "./demande.vue?vue&type=script&lang=js"
import style0 from "./demande.vue?vue&type=style&index=0&id=05133ef4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports